import { SerializedCapTableTransactionType } from '@commenda/types/src/cap-table/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export default function useCapTableTransactions(
  corporationId: number,
  token?: string
) {
  const {
    data,
    error,
    mutate,
  }: {
    data?: SerializedCapTableTransactionType[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `capTable/transaction/byCorporationId/${corporationId}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
